import React, {
  useState,
  createContext,
  useMemo,
  useEffect,
  useContext,
} from "react";
import {
  Button,
  MenuItem,
  Modal,
  TextField,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../components/LoaderScreen";
import request from "../../Helpers/API";
import { ValCredito } from "./ValCredito";
import { FormatMoney } from "../../Helpers/FormatNumber";
import { ValOnlyNumber } from "../../Validators/ValOnlyNumber";
import { Moneda } from "../../Helpers/Moneda";
import PlantillaScreen from "../helpers/PlantillaScreen";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import EditIcon from "@mui/icons-material/Edit";
import SelectEjercicio from "../helpers/EjercicioTextfield";
const Context = createContext();

export const ScreenIntereseses = () => {
  const [informacion, setInformacion] = useState({
    open: false,
    item: -999,
    data: [],
    editar: 0,
  });

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const año = new Date().getFullYear();

  const [ejercicio, setEjercicio] = useState(año);

  const contextValue = useMemo(
    () => ({
      state: informacion,
      setState: setInformacion,
    }),
    [informacion, setInformacion]
  );

  const openModal = (item, editar) => {
    setInformacion({
      ...informacion,
      open: true,
      itemSeleccionado: item,
      editar,
    });
    setEjercicio(ejercicio);
  };

  const actualizarListado = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`InteresMensual/Listado?ejercicio=${ejercicio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setInformacion({
          ...informacion,
          data: result,
          open: false,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("INTERESES", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    actualizarListado();
  }, [ejercicio]);

  const onDescargar = (idinteres) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`InteresMensual/ObtenerDocumento?idinteres=${idinteres}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.documento;
        const downloadLink = document.createElement("a");
        const fileName = `INTERES ${result.mes}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };




  return (
    <PlantillaScreen
      titulo={"LISTADO DE INTERESES MHUSA"}
      className={"listado-tasa-intereses-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <Context.Provider value={contextValue}>
        <div className="credito-intereses-mhusa-container">
          <div className="credito-intereses-mhusa-buttons">
            <SelectEjercicio
              value={ejercicio}
              onChange={setEjercicio}
              rango={2}
            />
            <div
              className="credito-intereses-mhusa-buttons-guardar"
              onClick={() => openModal(ejercicio, 0)}
            >
              <AddCircleOutlineIcon /> Agregar
            </div>
          </div>
          <ModalAgregar
            ejercicio={ejercicio}
            updatedata={actualizarListado}
            itemSeleccionado={informacion.itemSeleccionado}
          />
          <div className="credito-intereses-mhusa-tabla scroll-4">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Periodo</th>
                  <th>Intereses 0 - 6 meses</th>
                  <th>Intereses mas 6 meses</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {informacion.data === undefined ||
                  informacion.data === null ||
                  informacion.data.length === 0 ? (
                  <></>
                ) : (
                  informacion.data.map((item) => (
                    <tr>
                      <td>
                        <div>
                          <CalendarMonthIcon />
                          {item.mes}
                        </div>
                      </td>
                      <td>{FormatMoney(item.interes)} %</td>
                      <td>{FormatMoney(item.interes2)} %</td>
                      <td onClick={() => openModal(item.idinteres, 1)}>
                        <div className="button-table-intereses update">
                          <EditIcon />
                          Editar
                        </div>
                      </td>
                      <td>
                        {item.tienedocumento > 0 ? (
                          <div
                            className="button-table-intereses download"
                            onClick={() => onDescargar(item.idinteres)}
                          >
                            <CloudDownloadIcon />
                            Descargar
                          </div>
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Context.Provider>
    </PlantillaScreen>
  );
};

function ModalAgregar({ ejercicio, updatedata, itemSeleccionado }) {

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [intereses, setIntereses] = useState({
    idinteres: -999,
    ejercicio: 0,
    periodo: 0,
    interes: 0,
    interes2: 0,
    estatus: 1,
    documento: "",
    extension: "",
    bejercicio: false,
    bperiodo: false,
    binteres: false,
    binteres2: false,
    editar: false,
  });

  const { state, setState } = useContext(Context);
  const closeModal = () => {
    setState({
      ...state,
      open: false,
    });
  };

  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    setIntereses({
      ...intereses,
      [prop]: sinComas,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };
  const Editar = () => {
    if (
      itemSeleccionado !== null ||
      itemSeleccionado !== "" ||
      itemSeleccionado !== -999 ||
      itemSeleccionado !== undefined
    ) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`InteresMensual/BuscarID?idinteres=${itemSeleccionado}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setIntereses({
            ...intereses,
            idinteres: result.idinteres,
            ejercicio: result.ejercicio,
            periodo: result.periodo,
            interes: result.interes,
            interes2: result.interes2,
            estatus: result.estatus,
          });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("INTERESES", JSON.stringify(error), "error");
        });
    } else {
      return;
    }
  };

  useEffect(() => {
    if (
      itemSeleccionado !== undefined &&
      itemSeleccionado !== null &&
      Number(itemSeleccionado) > 0 &&
      Number(itemSeleccionado) !== 2024 &&
      Number(itemSeleccionado) !== 2025
    ) {
      Editar();
    } else {
      setIntereses({
        idinteres: -999,
        ejercicio: 0,
        periodo: 0,
        interes: 0,
        interes2: 0,
        estatus: 1,
        documento: "",
        extension: "",
        bejercicio: false,
        bperiodo: false,
        binteres: false,
      });
    }
  }, [itemSeleccionado]);

  const onGuardar = () => {
    var result = ValCredito(intereses);
    if (result.isValid === false) {
      Swal.fire("INTERESES", JSON.stringify(result.mensaje), "error");

    }
    else if (intereses.documento === null || intereses.documento === "" || intereses.documento === 0) {
      Swal.fire({
        title: "INTERESES",
        text: "Favor de cargar documento antes de guardar",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    else {

      result.post.idinteres = intereses.idinteres;
      result.post.estatus = intereses.estatus;
      result.post.ejercicio = ejercicio;
      result.post.documento = intereses.documento;
      result.post.extension = intereses.extension;

      if (result.post.interes <= 100 && result.post.interes2 <= 100) {
        setLoader({ ...loader, mostrar: true });
        request
          .post("InteresMensual", result.post)
          .then(async () => {
            setLoader({ ...loader, mostrar: false });
            await Swal.fire({
              title: "INTERESES",
              text: "Registro guardado con éxito",
              icon: "success",
              customClass: {
                container: "mi-superpoop",
              },
            });
            setIntereses({
              ...intereses,
              idinteres: -999,
              ejercicio: 0,
              periodo: 0,
              interes: 0,
              interes2: 0,
              estatus: 1,
              documento: "",
              extension: "",
              bejercicio: false,
              bperiodo: false,
              binteres: false,
              binteres2: false,
              editar: false,
            });
            closeModal();
            updatedata();
            // setState({ ...state, open: false })
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("INTERESES", JSON.stringify(error), "error");
          });
      } else {
        Swal.fire(
          "INTERESES",
          JSON.stringify("El interes no debe de ser mayor a 100"),
          "error"
        );
      }
    }
  };

  const GetFile = ({ target }) => {
    const file = target.files[0].name.split(".");
    if (file.length > 2) {
      Swal.fire("Clientes", "Archivo invalido", "error");
      return;
    }

    if (
      file[1] !== "jpg" &&
      file[1] !== "jepg" &&
      file[1] !== "pdf" &&
      file[1] !== "PDF"
    ) {
      Swal.fire("Clientes", "Archivo con formato no valido", "error");
      target.value = "";
      return;
    }
    var fReader = new FileReader();
    fReader.readAsDataURL(target.files[0]);
    fReader.onloadend = function (event) {
      setIntereses({
        ...intereses,
        documento: event.target.result,
        extension: file[1],
      });
    };
  };
  return (
    <Modal open={state.open}>
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <LoaderScreen loader={loader} />
        <div className="credito-agregar-modal-title">
          <h2>
            AGREGAR INTERESES{" "}
            <span style={{ color: "#035917" }}>{ejercicio}</span>
          </h2>
        </div>
        <div className=""></div>

        <div>
          <div>
            <TextField
              id="clientes-documento"
              type="file"
              onChange={GetFile}
              sx={{ mb: 2, width: 540 }}
            />
          </div>
          <div className="">
            <TextField
              fullWidth
              size="small"
              label="Periodo"
              variant="outlined"
              select
              value={intereses.periodo}
              type="text"
              disabled={state.editar === 1 ? true : false}
              onChange={({ target }) => {
                setIntereses({
                  ...intereses,

                  periodo: target.value,
                  bperiodo: false,
                });
              }}
            >
              <MenuItem value={"1"}>ENERO</MenuItem>
              <MenuItem value={"2"}>FEBRERO</MenuItem>
              <MenuItem value={"3"}>MARZO</MenuItem>
              <MenuItem value={"4"}>ABRIL</MenuItem>
              <MenuItem value={"5"}>MAYO</MenuItem>
              <MenuItem value={"6"}>JUNIO</MenuItem>
              <MenuItem value={"7"}>JULIO</MenuItem>
              <MenuItem value={"8"}>AGOSTO</MenuItem>
              <MenuItem value={"9"}>SEPTIEMBRE</MenuItem>
              <MenuItem value={"10"}>OCTUBRE</MenuItem>
              <MenuItem value={"11"}>NOVIEMBRE</MenuItem>
              <MenuItem value={"12"}>DICIEMBRE</MenuItem>
            </TextField>
          </div>
          <div className="credito-intereses-modal-container">
            <TextField
              fullWidth
              id="interes"
              size="small"
              label="Interés 0 - 6 meses"
              variant="outlined"
              type="text"
              inputProps={{
                style: { textAlign: "right", height: "23px" },
              }}
              error={state.binteres}
              onChange={({ target }) => {
                ValOnlyNumber("interes", target.value, onChange, true, 10);
              }}
              value={intereses.interes}
              onKeyUp={(input) => Moneda(input.target)}
            ></TextField>

            <TextField
              fullWidth
              id="interes2"
              size="small"
              label="Interés mas 6 meses"
              variant="outlined"
              type="text"
              inputProps={{
                style: { textAlign: "right", height: "23px" },
              }}
              error={state.binteres2}
              onChange={({ target }) => {
                ValOnlyNumber("interes2", target.value, onChange, true, 10);
              }}
              value={intereses.interes2}
              onKeyUp={(input) => Moneda(input.target)}
            ></TextField>
          </div>
        </div>

        <div className="credito-crear-interes-modal-button-container ">
          <Button onClick={closeModal} variant="contained" color="error">
            Cerrar
          </Button>
          <Button variant="contained" onClick={() => onGuardar()}>
            Agregar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
